module.exports = __webpack_public_path__ + "img/UI_BannerLoginIn.09fa6df9.png";